import { Router } from "express";
import { db } from "@workspace/db";
import { plansTable } from "@workspace/db";
import { eq, sql } from "drizzle-orm";
import { requireAuth, requireAdmin, type AuthRequest } from "../lib/auth";

const router = Router();

/* ─── Public billing settings (VAT enabled) ─────────────────────── */
router.get("/billing/settings", async (_req, res, next) => {
  try {
    const rows = await db.execute(sql`SELECT value FROM platform_settings WHERE key = 'vat_enabled'`);
    const value = (rows.rows?.[0] as any)?.value;
    const vatEnabled = value === "false" ? false : true; // Default to true
    res.json({ vatEnabled });
  } catch (err) { next(err); }
});

router.get("/plans", async (_req, res, next) => {
  try {
    const plans = await db
      .select()
      .from(plansTable)
      .where(eq(plansTable.isActive, true));
    res.json(plans);
  } catch (err) {
    next(err);
  }
});

router.post("/plans", requireAdmin, async (req: AuthRequest, res, next) => {
  try {
    const plan = await db
      .insert(plansTable)
      .values(req.body)
      .returning();
    res.status(201).json(plan[0]);
  } catch (err) {
    next(err);
  }
});

router.patch("/plans/:planId", requireAdmin, async (req: AuthRequest, res, next) => {
  try {
    const updated = await db
      .update(plansTable)
      .set({ ...req.body, updatedAt: new Date() })
      .where(eq(plansTable.id, Number(req.params.planId)))
      .returning();
    if (!updated[0]) return res.status(404).json({ error: "Plan not found" });
    res.json(updated[0]);
  } catch (err) {
    next(err);
  }
});

router.delete("/plans/:planId", requireAdmin, async (req: AuthRequest, res, next) => {
  try {
    await db
      .update(plansTable)
      .set({ isActive: false, updatedAt: new Date() })
      .where(eq(plansTable.id, Number(req.params.planId)));
    res.status(204).send();
  } catch (err) {
    next(err);
  }
});

export default router;
